<div class="player-wrapper" [class.compact]="compact">
  <video
    *ngIf="videoUrl"
    [src]="videoUrl"
    [poster]="posterUrl"
    [attr.title]="title"
    controls
    preload="metadata"
    playsinline
    class="video-element"
  >
    Your browser does not support the video tag.
  </video>
  <div *ngIf="!videoUrl" class="player-placeholder">
    <span>No video available</span>
  </div>
</div>
